<template>
  <top-bar>
    <div class="row agent-bar-mobile"
      :class="{ active: advanceSearch }">      
        <div class="mobile-search-header">
          <div class="mobile-page-title">
            {{ $t('main.DRAWER_AGENT_SEARCH') }}
          </div>
          <div>
            <button
              class="btn btn-default search-again-btn"
              type="button"
              @click="toggleMobileFilter()"
              v-show="!advanceSearch">
              <span class="glyphicon glyphicon-search"></span>
              {{ $t('find.SEARCH_AGAIN') }}
            </button>
            <round-button
              @click.native="cancelMobileFilter"
              :name="`　${$t('find.CANCEL')}　`"
              :backgroundColor="'#fff15d'"
              v-show="advanceSearch"
            />  
          </div>
        </div>

        <div v-if="!isFetchingAgents && !advanceSearch" 
          class="padding" :class="{ 'agent-count': true, 'is-mobile': $md.mobile }">
          {{ $t('find.WE_FIND') }}  {{ agentCount }} {{ $t('find.PCS') }}{{ $t('find.AGENTS') }}
        </div>

        <page-filter
            class="filter" 
            :page="'agent'"             
            :advanceSearch="advanceSearch" />

        <div class="mobile-filter-container">
          <autocomplete-search
            class="mobile-filter"
            v-show="advanceSearch"
            :search-options="keywordsSearchOptions"
            :placeholder="$t('find.AGENT_INPUT_TEXT')" />

          <mobile-ics-filter
            v-show="advanceSearch"
            :icsType="icsType"
            @change="updateFilter"
          ></mobile-ics-filter>
          
          <mobile-district-filter
            v-show="advanceSearch"
            :name="mobileSelectDistrict"
            :ics="icsType"
            :districts="districts"
            @changeDistrict="updateDistrictFilter" />

          <agent-filter
            v-show="advanceSearch"
            :isMitaclub="isMitaclub"
            :isManager="isManager"
            :isSales="isSales"
            @changeAgentType="updateFilter"
          ></agent-filter>

          <div class="mobile-search-field mobile-search-btn-group"
            v-show="advanceSearch">
            <button
              class="btn btn-default cancel-btn"
              type="button"
              @click="resetFilter">
              {{ $t('find.MOBILE_RESET') }}
            </button>
            <button
              class="btn btn-default mobile-search-btn"
              type="button"
              @click="cancelMobileFilter">
              <span class="glyphicon glyphicon-search"></span>
              {{ $t('find.SEARCH') }}
            </button>
          </div>  
        </div>
        
    </div>
  </top-bar>
</template>

<script>
import TopBar from '@/components/TopBar';
import PageFilter from '@/components/Home/Filters/Page';
import RoundButton from '@/components/RoundButton';
import MobileIcsFilter from '@/components/Stock/Filters/MobileIcsFilter';
import MobileDistrictFilter from '@/components/Stock/Filters/MobileDistrictField';
import AutocompleteSearch from '@/components/Stock/AutocompleteSearch/DropdownInput';
import AgentFilter from '@/components/Agent/Filters/AgentType';

export default {
  props: [ 'icsType', 'districts', 'isMitaclub', 'isManager', 'isSales', 'isFetchingAgents', 'agentCount', 'advanceSearch' ],
  components: {
    TopBar,
    PageFilter,
    RoundButton,
    MobileIcsFilter,
    MobileDistrictFilter,
    AutocompleteSearch,
    AgentFilter,
  },
  data () {
    return {
      mobileTempFilter: {},
      mobileTempDisplayPage: 1,
      mobileInitialFilters: null,
      mobileFilterPrePosition: false,
    }
  },
  computed: {
    mobileSelectDistrict() {
      if (this.districts.length > 0) {
        return this.$i18n.locale === 'en' ?
          `${this.districts.length} district(s) selected` :
          `已選 ${this.districts.length} 個地區`;
      }
      return this.$t('find.ALL_DISTRICT');
    },
    keywordsSearchOptions() {
      return {
        icsType: this.icsType,
        keywordType: 'emp',
      };
    },
  },
  methods: {
    resetFilter() {
      this.$emit('resetMobileFilter');
    },
    updateFilter(filter) {
      this.$emit('changeMobileFilter', filter);
    },
    updateDistrictFilter(districts) {
      this.$emit('changeMobileDistrict', districts);
    },
    updateMobileFilter(filter) {
      this.mobileTempFilter = {
        ...this.mobileTempFilter,
        ...filter,
      };
      this.mobileFilterPrePosition = 0;
      this.updateFilter(this.mobileTempFilter);
      this.mobileTempFilter = {};
      this.displayPage = 1;
      window.scrollTo(0, 0);
    },
    toggleMobileFilter() {
      if (this.advanceSearch) {
        this.$nextTick(() => {
          window.scrollTo(0, this.mobileFilterPrePosition);
        });
      } else {
        this.mobileFilterPrePosition = window.scrollY;
        window.scrollTo(0, 0);
        this.mobileDistrictActive = false;
      }
      this.mobileTempDisplayPage = this.displayPage;
      this.mobileInitialFilters = { ...this.filters };
      this.$emit('triggerAdvanceSearch', !this.advanceSearch);
    },
    cancelMobileFilter() {
      //this.displayPage = this.tempDisplayPage;
      this.tempDisplayPage = 0;
      //let cursor = (this.displayPage - 1) * this.pageDisplay;
      //this.updateFilterWithCursor({filters: this.initialFilters, cursor: cursor});
            
      this.$emit('triggerAdvanceSearch', false);
    },
  },
};
</script>

<style scoped>
.agent-bar-mobile {
  max-height: calc(100vh - 40px);
  overflow-y: scroll;
  background: #fff15d;
  padding-top: 10px;
  width: 100vw;
}

.padding {
  padding: 0 15px 5px 15px;
}

.filter {
  margin: 0 15px 10px 15px;
}

.mobile-filter {
  margin-bottom: 5px;
}

.agent-bar-mobile.active {
  position: fixed;
  min-height: calc(100vh - 40px);
}

.mobile-search-header {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;  
  margin-bottom: 5px;
  padding: 0 15px;
}

.mobile-filter-container {
  padding: 0 15px;
}

.mobile-page-title {
  font-size: 1.7rem;
  font-weight: 400;
}

.search-again-btn {
  background: #000000;
  color: #FEE100;
  border: 1px solid #000000;
  border-radius: 6px;
  padding: 4px 16px;
  font-size: 16px;
}

.mobile-search-btn-group {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.mobile-search-btn-group > button {
  flex: 0 1 30%;
  font-size: 16px;
  box-shadow: unset;
  outline-width: 0px;
  margin: 0 10px;
}
.cancel-btn {
  background: #FFFE80;
  color: #000000;
  border: 1px solid #FFFE80;
}
.mobile-search-btn {
  background: #000000;
  color: #FEE100;
  border: 1px solid #000000;
  border-radius: 8px;
}

</style>